// A compact port of the marketing homepage's hero illustration
// (site/index.html #hero-art): an assistant window calling get_weather,
// its real result, and one card labelled Sponsored underneath. Purely
// decorative — callers wrap it with aria-hidden — and colored entirely
// from the portal's CSS variables (see .auth-hero-* in shell.css) so it
// tracks light/dark theme automatically.

function Row({ y, text, mono, dim }: { y: number; text: string; mono?: boolean; dim?: boolean }) {
  return (
    <text x="34" y={y} className={`auth-hero-row-text${mono ? " auth-hero-mono" : ""}${dim ? " auth-hero-dim" : ""}`}>
      {text}
    </text>
  );
}

export function AuthHeroIllustration() {
  return (
    <svg viewBox="0 0 360 246" focusable="false" className="auth-hero-svg">
      {/* Window chrome */}
      <rect x="1" y="1" width="358" height="244" rx="20" className="auth-hero-window" />
      <path d="M1 38h358" className="auth-hero-titlebar-rule" />
      <circle cx="22" cy="19.5" r="3.5" className="auth-hero-dot" />
      <circle cx="36" cy="19.5" r="3.5" className="auth-hero-dot" />
      <circle cx="50" cy="19.5" r="3.5" className="auth-hero-dot" />
      <text x="66" y="24" className="auth-hero-mono auth-hero-dim">
        weather-mcp-server
      </text>

      {/* Tool call */}
      <rect x="20" y="54" width="320" height="30" rx="9" className="auth-hero-tool" />
      <Row y={73} text='get_weather(city: "Oslo")' mono dim />

      {/* Tool result */}
      <rect x="20" y="96" width="320" height="42" rx="11" className="auth-hero-result" />
      <Row y={122} text="Sunny in Oslo, 14°C" />

      {/* Sponsored card */}
      <rect x="20" y="150" width="320" height="82" rx="13" className="auth-hero-sponsored" />
      <rect x="34" y="162" width="90" height="20" rx="10" className="auth-hero-tag" />
      <text x="46" y="176" className="auth-hero-tag-text">
        SPONSORED
      </text>
      <text x="34" y="205" className="auth-hero-sponsor-name">
        Fjell Outdoor Co.
      </text>
      <text x="34" y="222" className="auth-hero-dim auth-hero-sponsor-copy">
        Hiking gear for clear-sky days
      </text>
    </svg>
  );
}
